import { render, staticRenderFns } from "./authUser.vue?vue&type=template&id=53cd22aa&scoped=true"
import script from "./authUser.vue?vue&type=script&lang=js"
export * from "./authUser.vue?vue&type=script&lang=js"
import style0 from "./authUser.vue?vue&type=style&index=0&id=53cd22aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd22aa",
  null
  
)

export default component.exports